import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { axiosInstance } from '@/lib/axios';

const LanguageSelector = ({ compact = false }) => {
  const { i18n } = useTranslation();

  const changeLanguage = async (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
    // Persist to backend (fire-and-forget)
    try {
      await axiosInstance.patch('/user/profile', { language: lng });
    } catch (e) {
      // Ignore - works offline via localStorage
    }
  };

  const currentLang = i18n.language?.startsWith('es') ? 'es' : 'en';

  if (compact) {
    return (
      <Button
        variant="ghost"
        size="sm"
        onClick={() => changeLanguage(currentLang === 'en' ? 'es' : 'en')}
        className="gap-1 px-2"
        data-testid="language-toggle-compact"
      >
        <Globe className="w-4 h-4" />
        <span className="text-xs font-medium uppercase">{currentLang}</span>
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5" data-testid="language-selector">
          <Globe className="w-4 h-4" />
          <span className="text-xs font-medium uppercase">{currentLang}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => changeLanguage('en')}
          className={currentLang === 'en' ? 'bg-orange-50 text-orange-700' : ''}
          data-testid="language-option-en"
        >
          English
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('es')}
          className={currentLang === 'es' ? 'bg-orange-50 text-orange-700' : ''}
          data-testid="language-option-es"
        >
          Español
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
